let filterLinksArray = document.querySelectorAll('.filtering-list__itemByValue'),
    filterPriceLinksArray = document.querySelectorAll('.filtering-list__itemByPrice'),
    currentWindowHeight = window.innerHeight;

function getPriceFromString(priceString) {
  let number = parseFloat(priceString.replace(/[^0-9,.]/g, '').replace('.', '').replace('$', ''));

  if (priceString.length <= 4) {
    number = `${number}00`;
  }

  return +number;
}

function filterFunctionality() {
  let filterTitle = document.querySelector('.collectionFullpage__filterTitle'),
      closeButtons = document.querySelectorAll('.collection-filtering__closeButton'),
      productPreviewLinks = document.querySelectorAll('.quick-add__sizes a'),
      applyFiltersButton = document.querySelector('.fullpageCollectionFilter__buttonApply'),
      cancelFiltersButton = document.querySelector('.fullpageCollectionFilter__buttonLink');

  if (filterTitle) {
    filterTitle.addEventListener('click', (e) => {
      e.preventDefault();
      openFilter();
    });

    filterTitle.addEventListener('keydown', (e) => {
      e.preventDefault();

      if (e.key === 13 || e.key === 'Enter') {
        openFilter(e);
      }
    });
  }

  closeButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      closeFilter();
    });
  });

  productPreviewLinks.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      productPreviewLinkActive(event);
    });
  });

  if (applyFiltersButton) {
    applyFiltersButton.addEventListener('click', showFilteredProducts);
  }

  if (cancelFiltersButton) {
    cancelFiltersButton.addEventListener('click', clearFilters);
  }
}

filterLinksArray.forEach(link => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    createFilterArray(event);
  });
});

filterPriceLinksArray.forEach(link => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    createPriceFilterArray(event);
  });
});

function clearFilters() {
  let activeItemsArray = document.querySelectorAll('.filtering-list__item--active');

  activeItemsArray.forEach(item => {
    item.classList.remove('filtering-list__item--active');
  });
}

function productPreviewLinkActive(event) {
  let currentLink = event.currentTarget,
      linkSizePicker = currentLink.closest('.quick-add__sizes'),
      linkSizePickerWrapper = currentLink.closest('.collectionFullpageProduct__contentFooter'),
      linksText = linkSizePickerWrapper.querySelectorAll('.collectionFullpageProduct__contentFooterButton span'),
      sizePickerActiveLink = linkSizePicker.querySelector('.quick-add__size--active'),
      sizePickerButton = linkSizePickerWrapper.querySelector('.collectionFullpageProduct__contentFooterButton');

  if(sizePickerActiveLink) {
    sizePickerActiveLink.classList.remove('quick-add__size--active');
    currentLink.classList.add('quick-add__size--active');
  } else {
    currentLink.classList.add('quick-add__size--active');
  }

  sizePickerButton.dataset.id = currentLink.dataset.id;
  sizePickerButton.dataset.inventoryQuantity = currentLink.dataset.inventoryQuantity;

  linksText.forEach(text => {
    text.dataset.inventoryQuantity = currentLink.dataset.inventoryQuantity;
    text.dataset.id = currentLink.dataset.id;
  });
};

function closeFilter() {
  let activeFilterList = document.querySelector('.collectionFullpage__filter.collectionFullpage__filter--active'),
      overlay = document.querySelector('.overlap'),
      body = document.querySelector('body');

  if (activeFilterList) {
    overlay.classList.remove('overlap--active');
    body.classList.remove('body--overflow');
    activeFilterList.classList.remove('collectionFullpage__filter--active');
  }
};

function createFilterArray(event) {
  let currentLink = event.currentTarget;

  currentLink.classList.toggle('filtering-list__item--active');
};

function createPriceFilterArray(event) {
  let currentLink = event.currentTarget,
      activeLink = document.querySelector('.filtering-list__itemByPrice.filtering-list__item--active');

  if (activeLink) {
    activeLink.classList.remove('filtering-list__item--active');
  }

  currentLink.classList.add('filtering-list__item--active');
};

async function showFilteredProducts() {
  let stringTags = '',
      activeFilterItems = document.querySelectorAll('.filtering-list__item--active'),
      filterArray = [],
      sizeFiltering = [],
      currentPage = document.location.href,
      sortValue = '';

  activeFilterItems.forEach(item => {
    let currentTag = item.dataset.tagFilter ? item.dataset.tagFilter : item.dataset.value;

    if (currentTag.includes('size')) {
      sizeFiltering.push(currentTag.replace('+', ''));
    }

    if (filterArray.includes(currentTag)) {
      let sameTag = filterArray.indexOf(currentTag);
      filterArray.splice(sameTag, 1);
    } else {
      filterArray.push(currentTag);
    }
  });

  filterArray.forEach(tag => {
    if (!tag.includes('?sort_by')) {
      stringTags += tag;
    }
  });

  filterArray.forEach(tag => {
    if (tag.includes('?sort_by')) {
      stringTags += tag;
    }
  });

  if (stringTags.includes('sort_by')) {
    const priceSortIndex = stringTags.indexOf('price-');

    if (priceSortIndex !== -1) {
      const priceSortValue = stringTags.slice(priceSortIndex);

      sortValue = priceSortValue.includes('ascending') ? 'ascending' : 'descending';
    }
  }

  try {
    const response = await fetch(`${currentPage}/${stringTags}`);

    if (response.ok) {
      const data = await response.text();
      const pageWrapper = document.querySelector('.collectionFullpage__list');
      const parser = new DOMParser();
      const collectionPage = parser.parseFromString(data, "text/html");
      let filteredProductsArray = Array.from(collectionPage.querySelectorAll('.product__wrapper:not(.spotlight)'));

      if (stringTags === '' && document.querySelector('.pagination__nextLink--hidden')) {
        document.querySelector('.pagination__nextLink').classList.remove('pagination__nextLink--hidden');
      }

      const loadMoreButton = document.querySelector('.pagination__nextLink');
      pageWrapper.innerHTML = '';

      if (stringTags !== '') {
        loadMoreButton?.classList.add('pagination__nextLink--hidden');
      }

      let filteredProducts = sizeFiltering.length
        ? filteredProductsArray.filter(product => sizeFiltering.some(tag => product.dataset.size.includes(tag)))
        : filteredProductsArray;

      if (sortValue) {
        filteredProducts = filteredProducts.sort((a, b) => {
          const priceA = a.querySelector('.collectionFullpageProduct__contentHeaderPriceNew')
            ? getPriceFromString(a.querySelector('.collectionFullpageProduct__contentHeaderPriceNew').innerText)
            : getPriceFromString(a.querySelector('.collectionFullpageProduct__price').innerText);
          const priceB = b.querySelector('.collectionFullpageProduct__contentHeaderPriceNew')
            ? getPriceFromString(b.querySelector('.collectionFullpageProduct__contentHeaderPriceNew').innerText)
            : getPriceFromString(b.querySelector('.collectionFullpageProduct__price').innerText);
          return priceB - priceA;
        });

        if (sortValue !== 'descending') {
          filteredProducts.reverse();
        }
      }

      const pageMarkup = filteredProducts.map(product => product.outerHTML).join('');

      pageWrapper.innerHTML = pageMarkup;

      if (
        collectionPage.querySelector('[data-all-pages]') &&
        parseInt(collectionPage.querySelector('[data-this-page]').value) <= parseInt(collectionPage.querySelector('[data-all-pages]').value)
      ) {
        const nextPaginationPage = collectionPage.querySelector('[data-next-link]').value;
        const nextStepPagination = parseInt(collectionPage.querySelector('[data-this-page]').value) + 1;
        collectionPage.querySelector('[data-this-page]').value = nextStepPagination;

        const nextResponse = await fetch(`${nextPaginationPage}`);

        if (nextResponse.ok) {
          const nextData = await nextResponse.text();
          const nextCollectionPage = parser.parseFromString(nextData, "text/html");
          const nextFilteredProductsArray = Array.from(nextCollectionPage.querySelectorAll('.product__wrapper:not(.spotlight)'));

          let nextFilteredProducts = sizeFiltering.length
            ? nextFilteredProductsArray.filter(product => sizeFiltering.some(tag => product.dataset.size.includes(tag)))
            : nextFilteredProductsArray;

          if (sortValue) {
            nextFilteredProducts = nextFilteredProducts.sort((a, b) => {
              const priceA = a.querySelector('.collectionFullpageProduct__contentHeaderPriceNew')
                ? getPriceFromString(a.querySelector('.collectionFullpageProduct__contentHeaderPriceNew').innerText)
                : getPriceFromString(a.querySelector('.collectionFullpageProduct__price').innerText);
              const priceB = b.querySelector('.collectionFullpageProduct__contentHeaderPriceNew')
                ? getPriceFromString(b.querySelector('.collectionFullpageProduct__contentHeaderPriceNew').innerText)
                : getPriceFromString(b.querySelector('.collectionFullpageProduct__price').innerText);
              return priceB - priceA;
            });

            if (sortValue !== 'descending') {
              nextFilteredProducts.reverse();
            }
          }

          const nextPageMarkup = nextFilteredProducts.map(product => product.outerHTML).join('');

          pageWrapper.insertAdjacentHTML('beforeend', nextPageMarkup);

          setTimeout(() => {
            let productsArray = document.querySelectorAll('.product__wrapper');
            productsArray.forEach((product, i) => {
              product.style.opacity = 1;
              product.style.transitionDelay = `1s`;
            });
          }, 1000);
        }
      }

      setTimeout(() => {
        fadeoutFunctionality();

        let productsArray = document.querySelectorAll('.product__wrapper');

        productsArray.forEach((product, i) => {
          product.style.opacity = 1;
          product.style.transitionDelay = `${i / 10}s`;
        });

        closeFilter();
      }, 1000);

      setTimeout(() => {
        addToCartFunctionlity();
        filterFunctionality();
      }, 3000);
    }
  } catch (error) {
    console.error("Error loading filtered products:", error);
  }
}


function isSafari() {
  return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
  navigator.userAgent &&
  navigator.userAgent.indexOf('CriOS') == -1 &&
  navigator.userAgent.indexOf('FxiOS') == -1;
};

function openFilter() {
  let filterList = document.querySelector('.collectionFullpage__filter'),
      overlay = document.querySelector('.overlap'),
      body = document.querySelector('body');

  if (filterList) {
    filterList.classList.add('collectionFullpage__filter--active');
    overlay.classList.add('overlap--active');
    body.classList.add('body--overflow');
  }

  if (isSafari()) {
    if (
      currentWindowHeight == window.innerHeight
      || currentWindowHeight + 1 == window.innerHeight
    ) {
      document.documentElement.style.setProperty('--filters-height', `80px`);
    } else {
      document.documentElement.style.setProperty('--filters-height', `0px`);
    }
  }
};

function fadeoutFunctionality() {
  let collectionLinksArray = document.querySelectorAll('.collectionFullpage a:not(.quick-add__size)');

  function fadeout() {
    let collectionWrapper = document.querySelector('.wrapper');

    collectionWrapper.classList.add('wrapper--opacity');
  }

  collectionLinksArray.forEach(link => {
    link.addEventListener('click', fadeout);
  });
}

filterFunctionality();
fadeoutFunctionality();

if ((/iphone|ipod|ipad.*os 5/gi).test(navigator.appVersion)) {
  window.onpageshow = function(evt) {
    if (evt.persisted) {
      let collectionWrapper = document.querySelector('.wrapper');

      setTimeout(() => {
        collectionWrapper.classList.remove('wrapper--opacity');
      }, 1000);
    }
  };
}

(function() {
  let totalPages = parseInt($('[data-all-pages]').val()),
      currentPage = parseInt($('[data-this-page]').val()),
      current_page_new = currentPage + 1;

  if(isNaN(current_page_new) && isNaN(totalPages)) {
    $('.collectionFullpage__link').remove();
  }
})();

$(window).on('scroll', function(event){
  var $this = $(this),
      totalPages = parseInt($('[data-all-pages]').val()),
      currentPage = parseInt($('[data-this-page]').val()),
      datacollurl = $('[data-coll-url]').val(),
      footer = $('footer'),
      target = $(this),
      nextLinkPagination = $('.pagination__nextLink:not(.pagination__nextLink--hidden)');

  if (nextLinkPagination.length > 0) {
    if (($.active <= 0) && (target.scrollTop() > (footer.offset().top - target.height() * 2))) {
      var nextUrl = $('[data-next-link]').val();
      var current_page_new = currentPage + 1;
      var next_coll = currentPage + 2;

      $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function(responseHTML) {
          let nextProductsArray = $(responseHTML).find('.product__wrapper:not(.spotlight)');

          $('[data-next-link]').val(datacollurl + "?page="+next_coll);
          $('[data-this-page]').val(current_page_new);
          $('.collectionFullpage__list').append(nextProductsArray).html();
          $this.removeClass('collectionFullpage__link--disable');

          setTimeout(function() {
            nextProductsArray.each( function(i) {
              let delayTime = i / 10;

              $(this).css({
                'transition-delay': `${delayTime}s`,
                'opacity': 1,
              });
            });
          }, 1);
        },
        complete: function() {
          if (getCookie('isFirstCustomer')) {
            window.toggleFirstCustomerDiscount();
          }

          if(current_page_new >= totalPages) {
            filterFunctionality();
            addToCartFunctionlity();
            fadeoutFunctionality();
          }
        }
      })
    }
  }
});

(function() {
  const collectionProductsArray = document.querySelectorAll('.product__wrapper'),
        spotlightsArray = document.querySelectorAll('.spotlight');

  async function addSpotlights() {
    spotlightsArray.forEach(spotlight => {
      let spotlightPosition = spotlight.dataset.position;

      if (spotlightPosition && collectionProductsArray[spotlightPosition]) {
        collectionProductsArray[spotlightPosition].insertAdjacentHTML("beforebegin", spotlight.outerHTML);
      }
    });

    await checkSpotlightsPosition();
    await scrollToSection();
  }

  async function checkSpotlightsPosition() {
    if (window.innerWidth <= 768) {
      const platesArray = document.querySelectorAll('.collectionFullpage__list .product__wrapper');

      platesArray.forEach((plate, index) => {
        if (plate.classList.contains('spotlight') && platesArray[index + 1].classList.contains('spotlight') && (index % 2 == 0)) {
          plate.classList.add('spotlight--marginZero');
          platesArray[index + 1].classList.add('spotlight--marginZero');
        }
      });
    }
  }

  async function scrollToSection() {
    const urlHash = window.location.hash;

    if (urlHash) {
      const targetSection = document.querySelector(`.${urlHash.slice(1)}`);

      if (targetSection) {
        const elementRect = targetSection.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);

        window.scrollTo({
          top: middle,
          behavior: 'smooth'
        });

        targetSection.focus({ preventScroll: true });
      }
    }
  }

  addSpotlights();
})();
